<template>
  <div>
    <v-row v-if="keyValue == 1 && isCreateAction" dense>
      <v-col :cols="12" :md="12">
        <validation-provider v-slot="{ errors }" rules="required" name="Ключ">
          <v-text-field
            v-model="formData.term"
            outlined
            dense
            :maxlength="64"
            label="Ключ"
            placeholder="Введите ключ"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col :cols="12" :md="12">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          name="Значение"
        >
          <v-text-field
            v-model="formData.value"
            outlined
            dense
            :maxlength="255"
            label="Значение"
            placeholder="Введите значение"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    action: {
      type: String,
      default: "create"
    },
    value: {
      type: Object,
      required: true
    },
    keyValue: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    const isCreateAction = computed(() => props.action === "create");
    const isEditAction = computed(() => props.action === "edit");

    return {
      formData,
      isCreateAction,
      isEditAction
    };
  }
};
</script>
